import React, { useState } from 'react';
import ForgetPassword from './ForgetPassword';
import ResetPassword2 from './ResetPassword2';
const EnterOTP = ({ closeModal }) => {
  const clickHandler = () => {
    closeModal(false);
  };
  const [otp, setOtp] = useState(new Array(4).fill(''));
  const handleChange = (element, index) => {
    if (isNaN(element.value)) return false;
    setOtp([...otp.map((d, idx) => (idx == index ? element.value : d))]);

    //Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }
  };
  const [openFP, setOpenFP] = useState(false);

  const forgotpasswordClickHandler = () => {
    setOpenFP(!openFP);
  };

  const [openFP2, setOpenFP2] = useState(false);

  const forgotpassword2ClickHandler = () => {
    setOpenFP2(!openFP2);
  };
  return (
    <div className='forgotpasswordModal'>
      <div id='ForgotPassword' className=''>
        <div className='m-5' style={{ width: '110%' }}>
          <div className='d-flex justify-content-end' onClick={clickHandler}>
            <button
              type='button'
              class='btn-close shadow-none'
              aria-label='Close'
            ></button>
          </div>
          <div className='d-block text-center'>
            <img
              src='/assests/logo2.png'
              alt='KIBI Sport'
              className='fluid-img'
            />
          </div>
          <div className='my-md-5 py-md-3'>
            <h1 className='modalHeader d-flex justify-content-center'>
              Enter OTP
            </h1>
            <div className='text-center pt-md-5 mt-0'>
              {otp.map((data, index) => {
                return (
                  <input
                    style={{ width: '8.8rem' }}
                    className='otp-field'
                    type='text'
                    maxLength='1'
                    // placeholder='Enter Your Email Address '
                    className=' p-3 rounded border border-secondary m-1'
                    key={index}
                    value={data}
                    onChange={(e) => handleChange(e.target, index)}
                    onFocus={(e) => e.target.select()}
                  />
                );
              })}

              <br />

              {/* <input
            type='email'
            name='email'
            value={email}
            onChange={OnChange}
            placeholder='Email Address'
            className='input-group p-3 rounded border border-secondary'
          />
          <br />
          <input
            type='text'
            name='phone'
            value={phone}
            onChange={OnChange}
            placeholder='Phone text'
            className='input-group p-3 rounded border border-secondary'
          />
          <br /> */}
              <div className='pt-3'>
                <button
                  type='submit'
                  className='loginBtn p-3 rounded border border-none'
                  onClick={forgotpassword2ClickHandler}
                >
                  Submit
                </button>
              </div>
            </div>
            <h5
              style={{ cursor: 'pointer', color: '#1C97CC' }}
              onClick={forgotpasswordClickHandler}
              className='text-decoration-underline text-center pt-4'
            >
              Resend OTP
            </h5>
          </div>
        </div>
      </div>
      {openFP && <ForgetPassword closeModal={setOpenFP} />}
      {openFP2 && <ResetPassword2 closeModal={setOpenFP2} />}
    </div>
  );
};

export default EnterOTP;
